module.exports = window["reactToastify"];